<template>
  <path fill="#03A9F4" :style="{fill : $attrs.fgColor}"
        d="M36.3,23.3c0.2-1.1,0.3-2.2,0.3-3.3c0-9.2-7.5-16.7-16.7-16.7c-1.1,0-2.3,0.1-3.3,0.3c-1.4-0.7-2.9-1.2-4.6-1.2
	c-5.3,0-9.6,4.3-9.6,9.6c0,1.7,0.4,3.2,1.2,4.6c-0.2,1.1-0.3,2.2-0.3,3.3c0,9.2,7.5,16.7,16.7,16.7c1.1,0,2.3-0.1,3.3-0.3
	c1.4,0.7,2.9,1.2,4.6,1.2c5.3,0,9.6-4.3,9.6-9.6C37.5,26.3,37.1,24.7,36.3,23.3z M20.5,30c-5.5,0-8-2.8-8-4.8c0-1.1,0.7-1.8,1.8-1.8
	c2.3,0,1.8,3.4,6.2,3.4c2.2,0,3.5-1.2,3.5-2.5c0-0.8-0.3-1.6-1.8-2L17.2,21c-3.9-1-4.7-3.2-4.7-5.3c0-4.2,3.9-5.7,7.6-5.7
	c3.4,0,7.3,1.8,7.3,4.3c0,1.1-0.8,1.8-1.9,1.8c-2,0-1.7-2.8-5.7-2.8c-2,0-3.2,0.9-3.2,2.3c0,1.3,1.6,1.7,3,2.1l3.7,0.8
	c4,0.9,4.9,3.2,4.9,5.5C28.2,27.4,25.7,30,20.5,30z"/>
</template>

<script>
export default {
  name: "svgSkype"
}
</script>

<style scoped>

</style>